import { OrganizationFeatures, PremiumFeature } from '@trello/product-features';
import { isEnterpriseOrg, isStandardOrg } from './features';

export const getPaidStatus = (
  premiumFeatures: PremiumFeature[],
  products: number[],
) => {
  return isEnterpriseOrg(premiumFeatures)
    ? 'enterprise'
    : isStandardOrg(products)
    ? 'standard'
    : OrganizationFeatures.hasProduct(products[0]) // need to do BC check after Standard, because this check would return true for a Standard org too
    ? 'bc'
    : 'free';
};
